"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    products: zod_1.z
        .array(zod_1.z.string().refine(
    // wow… Zod is so cool
    (val) => {
        const productFormatRegex = /^PRO\d+(US|AU)$/;
        return productFormatRegex.test(val);
    }, {
        message: "String must be in the format 'product_{number}_alt'",
    }))
        .nonempty(),
});
exports.path = '/landing-page-product-details';
//# sourceMappingURL=index.js.map